var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33301C4.32404 1.33301 1.33337 4.32367 1.33337 7.99967C1.33337 11.6757 4.32404 14.6663 8.00004 14.6663C11.676 14.6663 14.6667 11.6757 14.6667 7.99967C14.6667 4.32367 11.676 1.33301 8.00004 1.33301ZM8.00004 13.333C5.05937 13.333 2.66671 10.9403 2.66671 7.99967C2.66671 5.05901 5.05937 2.66634 8.00004 2.66634C10.9407 2.66634 13.3334 5.05901 13.3334 7.99967C13.3334 10.9403 10.9407 13.333 8.00004 13.333Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 4.66699H7.3335V8.27633L9.52883 10.4717L10.4715 9.52899L8.66683 7.72433V4.66699Z",
    fill: "#98A2B3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M8.00004 1.33301C4.32404 1.33301 1.33337 4.32367 1.33337 7.99967C1.33337 11.6757 4.32404 14.6663 8.00004 14.6663C11.676 14.6663 14.6667 11.6757 14.6667 7.99967C14.6667 4.32367 11.676 1.33301 8.00004 1.33301ZM8.00004 13.333C5.05937 13.333 2.66671 10.9403 2.66671 7.99967C2.66671 5.05901 5.05937 2.66634 8.00004 2.66634C10.9407 2.66634 13.3334 5.05901 13.3334 7.99967C13.3334 10.9403 10.9407 13.333 8.00004 13.333Z' fill='%2398A2B3'/%3e %3cpath d='M8.66683 4.66699H7.3335V8.27633L9.52883 10.4717L10.4715 9.52899L8.66683 7.72433V4.66699Z' fill='%2398A2B3'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };